import * as React from 'react';
import CommonChrome from '../CommonChrome';
export var Side = function Side() {
  return /*#__PURE__*/React.createElement(CommonChrome.Nav, {
    vertical: true,
    inverted: true
  });
};
export default Side;